import { Dialog, DialogContent } from "@mui/material";

import IContact, { IAddress } from "@/interfaces/contact.interface";
import { ContactInfoMessages } from "@/messages/contacts/contact-Info.messages";

import AddressSectionDialog from "../PersonalDetailsTab/components/addressSectionDialog";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  address: IAddress | null;
  contact: IContact | null;
  messages: ContactInfoMessages;
  isEditing: boolean;
}

const AddressDialog = ({ isOpen, onClose, contact, messages, address, isEditing }: Props) => {
  return (
    <Dialog open={isOpen} onClose={onClose} style={{ padding: 10 }} fullWidth maxWidth="xl">
      <DialogContent>
        <AddressSectionDialog
          messages={messages}
          contact={contact}
          address={address}
          isEditing={isEditing}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddressDialog;
